import axios from "axios";
import { env } from "../utils/env";
import { useAuth } from "../context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { AdditionalDocumentsList } from "../types/AdditionalDocumentsType";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";
import { displayError } from "../utils/error-handling";

type TypeFilter = "individual" | "entity";

const fetchAdditionalDocuments = async (
  authHeader: string,
  type?: TypeFilter,
) => {
  return axios.get<AdditionalDocumentsList[]>(
    `${env.verifyServiceUrl}individual/additional_document/`,
    {
      headers: { Authorization: authHeader },
      params: type ? { _type: type } : undefined,
      skipGlobalErrorHandler: true,
    } as any,
  );
};

export const useAllAdditionalDocuments = (type?: TypeFilter) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery({
    queryKey: ["addAdditionalDocuments", type],
    queryFn: () => fetchAdditionalDocuments(authHeader, type),
    retry: false,
    select: (response) => response.data,
    onError: (err: any) => {
      const message =
        err?.response?.data?.detail || "Failed to load additional documents.";

      displayError(message);

      if (err?.request?.status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    },
  });
};
